module.exports = __webpack_public_path__ + "static/img/delete-icon.1a0d7d3f.svg";